import axios from 'axios';
import { constant } from '../constant';

// Base URL configuration
const BASE_URL = 'https://hotelapi.meerana.ae/';

export const postApi = async (path, data) => {
  try {
    let result = await axios.post(`${BASE_URL}${path}`, data, {
      headers: {
        'Content-Type': 'application/json',
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    if (result) {
      return result;
    } else {
      return false;
    }
  } catch (e) {
    console.error('POST API Error:', e);
    return e;
  }
};

export const patchApi = async (path, data) => {
  try {
    let result = await axios.patch(`${BASE_URL}${path}`, data, {
      headers: {
        'Content-Type': 'application/json',
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    return result;
  } catch (e) {
    console.error('PATCH API Error:', e);
    return e;
  }
};

export const deleteApi = async (path, id) => {
  try {
    let result = await axios.delete(`${BASE_URL}${path}${id}`, {
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    return result;
  } catch (e) {
    console.error('DELETE API Error:', e);
    return e;
  }
};

export const deleteManyApi = async (path, data) => {
  try {
    let result = await axios.post(`${BASE_URL}${path}`, data, {
      headers: {
        'Content-Type': 'application/json',
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    if (result.data?.token && result.data?.token !== null) {
      localStorage.setItem('token', result.data?.token);
    }
    return result;
  } catch (e) {
    console.error('DELETE MANY API Error:', e);
    return e;
  }
};

export const getApi = async (path, id) => {
  try {
    // Fixed: removed the incorrect + operator
    const url = id ? `${BASE_URL}${path}${id}` : `${BASE_URL}${path}`;

    let result = await axios.get(url, {
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    return result;
  } catch (e) {
    console.error('GET API Error:', e);
    return e;
  }
};